import {writable} from "svelte/store";
const trainerClientGroupsCount = writable(0);
export {trainerClientGroupsCount};
